import type { HTMLChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
import React from 'react';

import { useColorMode } from 'toolkit/chakra/color-mode';

interface Props extends HTMLChakraProps<'svg'> {}

const NetworkGlyph = (props: Props) => {
  const { colorMode } = useColorMode();
  const primaryFill = colorMode === 'dark' ? 'white' : 'black';

  return (
    <chakra.svg viewBox="0 0 227 273" fill="none" flexShrink={ 0 } { ...props }>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.833 40.645L78.964 81.29L55.77 118.26C43.013 138.593 32.448 154.84 32.291 154.364C31.557 152.143 0 2.684 0 1.429C0 0.221001 4.842 0 31.351 0H62.703L70.833 40.645Z"
        fill={ primaryFill }
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.062 22.75C197.77 35.263 179.991 56.87 168.553 70.767C157.115 84.664 147.757 96.246 147.757 96.504C147.757 96.762 162.874 97.092 181.35 97.237L214.943 97.5L123.199 183C72.74 230.025 29.737 269.986 27.637 271.802C24.779 274.273 31.23 263.578 53.271 229.302L82.724 183.5L60.795 183.231L38.866 182.962L62.451 147.238C75.422 127.59 100.875 86.986 119.012 57.007C137.149 27.028 152.442 1.938 152.995 1.25C153.767 0.291 162.483 0 190.389 0H226.775L208.062 22.75Z"
        fill="#FFA32C"
      />
    </chakra.svg>
  );
};

export default React.memo(NetworkGlyph);
